import request from "domain/SiteAPI";
import { GET, POST } from "domain/SiteAPI/httpMethods";

export const getNewsletter = async (game_id) => {
    return await request({
        url: `newsletter`,
        method: GET,
        parameters: { game_id },
    });
};

export const createOrderNewsletter = async ({game_id, return_url}) => {
    return await request({
        url: `newsletter`,
        method: POST,
        body: { game_id, return_url },
    });
};
